
import { Fragment, useEffect, useRef, useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import Accordian from "../Accordian";
import HoverToolTip from "../HoverToolTip";
import ReactDOM, { unmountComponentAtNode } from "react-dom";
import VGPopUp from "vagaro-website-rendering/src/components/Controls/VGPopUp";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";


const allowTabOnKeyPress = (e:React.KeyboardEvent<HTMLTextAreaElement>,inputFunc?:Function)=>{

    if((e.key=="Tab"&&e.target)){
       
        e.preventDefault();


        let current = e.target as HTMLTextAreaElement;
        let start = current.selectionStart;
        let end = current.selectionEnd;

        let value = current.value;

   

        value = value.substring(0,start)+"\t"+value.substring(end);
        current.value = value;
        current.selectionStart = current.selectionEnd = start+1;

        inputFunc&&inputFunc(e);
  
        return false;
     

    }
}

const overridePaste = (event:any,inputFunc?:Function)=>{
        
    event.preventDefault();
    event.stopPropagation();
    const pastedText = (event.clipboardData || window.Clipboard).getData('text');

    const textarea = event.target;
    const startPos = textarea.selectionStart;
    const endPos = textarea.selectionEnd;
    const currentValue = textarea.value;
    const newValue = currentValue.substring(0, startPos) + pastedText + currentValue.substring(endPos);
    textarea.value = newValue;
  
    // Set the cursor position after the pasted content
    const newCursorPos = startPos + pastedText.length;
    textarea.setSelectionRange(newCursorPos, newCursorPos);
    inputFunc&&inputFunc(event);
    return false;

  

}
export default function CodeField({label,definition,layoutObject,updateFunc,saveFunc,screenSize,siteData,helpType}:AttributeFieldProps & {helpType?:string}){

    let key = definition.attKey;



    const isSimpleCss = (layoutObject.typename == wBComponentTypeNames.htmlEmbed);

    const cssPlaceHolder = (isSimpleCss)?"":
    `$all {
    \t
    }`
    //browser behavior prevents pasing things like <iframe into text box which is the exact reason we need this field in the first place. this method overrides this behavior


    let val = GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize, (helpType=="css")?cssPlaceHolder:"");
    const prevVal = useRef<string>(val);

    const calcWarnings = (val:string)=>{
        let twarning = "";

        if(isSimpleCss)
            return twarning;

        if(val.includes("transition")){
            twarning = "*using the <b><i>transition</i></b> attribute may affect how this component behaves when moving or resizing<br/>"
        }

        if(val.includes(" transform")||val.includes("\ntransform")||val.includes("\ttransform")){//check for empty space to avoid matching words like text-transform
            if(twarning.length>0)
                twarning+="<br/>";
            twarning += "*using the <b><i>transform</i></b> attribute may affect how this component behaves when moving resizing or animating<br/>"
        }

        if(val.length>0)
            val+="<br/>";

        return twarning;
    }
    const inputRef = useRef<any>(null);
 
    const [warning,setWraning] = useState<string>(calcWarnings(val));
    const triggerInput =(e:any)=>{

        const target = e.target;
        if(target){
            let current = target as HTMLInputElement;
            if(current){

                if(helpType=="css" ){
                    let val = current.value;
                    let replaced = val.replace(/\s/g, '');
                    //clear the value if nothing significant is entered
                    if(replaced=="$all{}"){
                        val = "";
                    }
        
                    updateFunc(key,val.trim(),definition.targetType);
                    siteData.onUpdateCustomCSS();
                    
                    let twarning = calcWarnings(val);
                    if(twarning!=warning)
                        setWraning(twarning);
                }
                else{
                   //let val = DOMPurify.sanitize(current.value);//sanitizeHtml(current.value);
                   let val = current.value.trim();
                    updateFunc(key,val,definition.targetType);
                }

            }


        }
    }


    useEffect(()=>{

        return ()=>{
            if(inputRef.current ){
                //linting is wrong, this ref wont be null
                // eslint-disable-next-line
                let val = inputRef.current.value;
                if(val!=prevVal.current){
                    prevVal.current = val;
          
                    saveFunc();
                }
            }
        }

    })


    const checkTab = (e:React.KeyboardEvent<HTMLTextAreaElement>)=>{

        if((e.key=="Tab"&&inputRef.current)){
           
            e.preventDefault();


            let current = inputRef.current as HTMLTextAreaElement;
            let start = current.selectionStart;
            let end = current.selectionEnd;

            let value = current.value;

            if(value=="" && helpType=="css" &&!isSimpleCss){

                current.value = cssPlaceHolder;
                current.selectionStart= 8;
                current.selectionEnd = 8;
                return false;
            }

            value = value.substring(0,start)+"\t"+value.substring(end);
            current.value = value;
            current.selectionStart = current.selectionEnd = start+1;

            triggerInput(e);
            return false;
         

        }

    }


return(

    <div className="wb-input-group ">
     <div className="flex-row justify-between align-start">
        <label className={(val==""||(val==cssPlaceHolder&&helpType=="css"))?"not-updated":"updated"}>{label}</label>
        <button className="invisible-button"
        
            onClick={()=>{


                if(inputRef.current)
                OpenCodeEditor(definition.label,inputRef.current.value,triggerInput,(val:string)=>{
                    if(inputRef.current){ inputRef.current.value = val; triggerInput({target:inputRef.current})};
                    saveFunc();
                })
            
            } }
        
        ><HoverToolTip text="open in editor"/><PopupIcon/></button>
     </div>
    <div className="wb-input-row">
        <textarea {...{spellCheck:"false"}} onPaste={(e)=>{overridePaste(e,triggerInput);}} className="css-text-area" defaultValue={val} ref={inputRef}  onInput={triggerInput}  onKeyDown={checkTab} placeholder={(helpType=="css")?cssPlaceHolder:definition.placeHolder} />
    </div>
    <div className="css-warning" dangerouslySetInnerHTML={{__html:warning}}></div>
    {helpType=="css"&&
    <div style={{padding:"8px"}}>
        <Accordian label="Help"  startExpanded={false} >
        <div className="input-description" style={{padding:"12px 0px 0px 0px"}}>
            <p>Use custom <a href="https://www.w3schools.com/css/" rel="noreferrer" target="_blank">CSS</a> to create advanced styles and behaviors.</p>
            {!isSimpleCss&&
            <>
            <label><strong>$all</strong>{" { /*css*/ }"}</label>
            <p>Target this component on all screen sizes</p>

            <label><strong>$tablet</strong>{" { /*css*/ }"}</label>
            <p>Target this component on tablet and mobile</p>

            <label><strong>$mobile</strong>{" { /*css*/ }"}</label>
            <p>Target this component on mobile only</p>
            </>
            }

        </div>
        </Accordian>
        </div>
    }
    </div>

)
}

const PopupIcon = ()=>{
    return <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" color="#eee"><path d="M432 48H208c-17.7 0-32 14.3-32 32V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V336h16c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V256H48V448zM64 128H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z"/></svg>

}

    
const OpenCodeEditor = (title:string,initialText:string,inputFunction:Function,onSave:Function)=>{
            
    const PopupClose = () => {
        let text = document.getElementById("code-text-area") as HTMLInputElement;

        if(text){
            onSave(text.value);
        }

        let dom = document.getElementById("OpenDialog");
        if (dom) unmountComponentAtNode(dom);
      
       
    };
    
   

    setTimeout(()=>{
        let dom = document.getElementById("code-text-area");
        if (dom) dom.focus();

    },100)

    ReactDOM.render(
        <VGPopUp
          id={"code-editor-popup"}
          show={true}
          onHide={PopupClose}
          title={title}
          dialogClassName="block-edit"
          body={
            <div className="alertContent">
                <textarea className="css-text-area full" onKeyDown={(e)=>{allowTabOnKeyPress(e,inputFunction)}} onPaste={(e)=>{overridePaste(e,inputFunction)}} id="code-text-area" defaultValue={initialText} spellCheck="false" onInput={ (e)=>{   inputFunction(e)}}></textarea>
            </div>
          }
          footer={
            <Fragment>
             
         
            <button className="w-button w-button-primary" onClick={(e) => { PopupClose()}}>Ok</button>
            </Fragment >
          }
          isRemoveTabModalIndex={false}
          isShowFooter={true}
          size={"modal-sm"}
          backdrop={true}
        />,
        document.getElementById("OpenDialog"));

}

      


